import React from "react";
import { MessageCircle } from "lucide-react";
import { motion } from "framer-motion";

export default function WhatsappFloat() {
  return (
    <motion.a
      href="https://wa.me/34617420491?text=Hola%20Mois%C3%A9s%2C%20me%20gustar%C3%ADa%20un%20presupuesto."
      target="_blank"
      rel="noreferrer"
      data-testid="floating-whatsapp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 220, damping: 18 }}
      className="fixed z-[90] bottom-5 right-5 sm:bottom-8 sm:right-8"
      aria-label="Abrir WhatsApp"
    >
      <span className="relative flex h-14 w-14 items-center justify-center">
        <span className="absolute inset-0 rounded-full bg-[#25D366] opacity-40 animate-ping" />
        <span className="absolute inset-0 rounded-full bg-[#25D366]" />
        <MessageCircle size={22} className="relative text-white" strokeWidth={2.2} />
      </span>
    </motion.a>
  );
}
